import { ROUTE } from "../../../routes";
import SharedPropsService from "../../../SharedPropsService";
import { nextStepCredStepper } from "../../../configs/utils";
import { AssetRepositoryMap, AssetRepositoryType, getAppHeader, getPrimaryAssetRepository } from "../../../configs/config";
import { api } from "../../../configs/api";
import _ from "lodash";
import AsyncStorage from "@react-native-async-storage/async-storage";
export const confirmAndGetOTP = async (action, _datastore, { network, navigate, setDatastore }) => {
    await setDatastore(ROUTE.VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT, "verifyInterestEnhanceLimit", {
        loading: true
    });
    const assetRepositoryType = await getPrimaryAssetRepository();
    AssetRepositoryMap.get(assetRepositoryType).LIST = [];
    action.payload.value.availableCAS.forEach((item) => {
        if (item.pledgedUnits > 0) {
            AssetRepositoryMap[item.assetRepository.toUpperCase()].LIST.push({
                ...item,
                is_pledged: true,
            });
        }
    });
    let applicationId = '';
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    /*** check if the user has selected both karvy and cams ***/
    const assetRepositoryConfig = await SharedPropsService.getAssetRepositoryFetchMap();
    /*** update the config if the user has selected both karvy and cams ***/
    for (const assetType of Object.keys(AssetRepositoryType)) {
        assetRepositoryConfig[assetType].isPledgedRequired =
            AssetRepositoryMap[assetType].LIST.length > 0;
        await SharedPropsService.setAssetRepositoryFetchMap(assetRepositoryConfig[assetType], assetType);
    }
    const body = {
        applicationId: applicationId,
        assetRepository: assetRepositoryType,
        portfolioItemList: AssetRepositoryMap[assetRepositoryType].LIST,
    };
    /**** check if user has empty portfolio then switch asset repository type ****/
    if (assetRepositoryType === AssetRepositoryType.KARVY &&
        AssetRepositoryMap[AssetRepositoryType.KARVY].LIST.length === 0) {
        body["assetRepository"] = AssetRepositoryType.CAMS;
        body["portfolioItemList"] =
            AssetRepositoryMap[AssetRepositoryType.CAMS].LIST;
        await SharedPropsService.setAssetRepositoryType(AssetRepositoryType.CAMS);
    }
    else if (assetRepositoryType === AssetRepositoryType.CAMS &&
        AssetRepositoryMap[AssetRepositoryType.CAMS].LIST.length === 0) {
        body["assetRepository"] = AssetRepositoryType.KARVY;
        body["portfolioItemList"] =
            AssetRepositoryMap[AssetRepositoryType.KARVY].LIST;
        await SharedPropsService.setAssetRepositoryType(AssetRepositoryType.KARVY);
    }
    /** actual api call with body */
    const response = await network.post(api.pledgeCreate, body, {
        headers: await getAppHeader(),
    });
    if (_.get(response, "data.status") === "SUCCESS") {
        await setDatastore(ROUTE.VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT, "verifyInterestEnhanceLimit", {
            loading: false
        });
        await navigate(ROUTE.PLEDGE_VERIFY, {
            assetRepository: AssetRepositoryMap[assetRepositoryType].NAME,
            sendOtpForPledgeConfirmAction: action,
        });
    }
};
export const needHelp = async (action, _datastore, { navigate, ...props }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const goBackAction = async (action, _datastore, { goBack }) => {
    await goBack();
};
let counter = 0;
export const activatePledge = async (action, _datastore, { network, navigateWithClear, setDatastore }) => {
    const pledgeDetails = action?.payload?.value;
    const totalCreditLimit = pledgeDetails?.drawingPower;
    await setDatastore(ROUTE.VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT, "verifyInterestEnhanceLimit", {
        loading: true,
        showErrorModal: false,
        counter: counter++
    });
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : (await SharedPropsService.getUser())
        .linkedApplications[0].applicationId;
    const activatePledge = await network.get(`${api.activateAsset}${applicationId}`, { headers: await getAppHeader(), handleFromMF: true });
    if (activatePledge?.status === 200) {
        const stepStatusMap = activatePledge?.data?.updatedApplicationObj?.stepStatusMap;
        const currentStepId = activatePledge?.data?.updatedApplicationObj?.currentStepId;
        const routeObj = await nextStepCredStepper(currentStepId);
        await navigateWithClear(routeObj.routeId, routeObj.params);
        await setDatastore(ROUTE.VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT, "verifyInterestEnhanceLimit", {
            loading: false,
            counter: counter++
        });
    }
    else if (activatePledge?.response?.status === 400) {
        if (activatePledge?.response?.data?.voltErrorCode === 'CREDIT_LIMIT_EXCEEDED') {
            await setDatastore(ROUTE.VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT, "verifyInterestEnhanceLimit", {
                showErrorModal: true,
                loading: false,
                errorTitle: 'Total credit limit cannot exceed ₹2Cr',
                // errorDesc:activatePledge?.response?.data?.message,
                errorDesc: "We'll notify you once higher credit limits can be provided",
                counter: counter++
            });
        }
    }
    else {
        await setDatastore(ROUTE.VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT, "verifyInterestEnhanceLimit", {
            showErrorModal: true,
            loading: false,
            errorTitle: 'Verification failed!',
            errorDesc: 'Something went wrong',
            counter: counter++
        });
    }
};
export const openKFSPage = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KFS_SCREEN);
};
export const closeErrorModal = async (action, _datastore, { setDatastore }) => {
    await setDatastore(ROUTE.VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT, "verifyInterestEnhanceLimit", {
        showErrorModal: false,
        loading: false,
        counter: counter++
    });
};
